import React from 'react'
import environment from '~/config/environment'

export default class MetadataSHAPage extends React.Component {
  render() {
    return <div>{environment.gitSha}</div>
  }
}
